import axiosClient from "../axiosClient";
import { CheckNullParams } from "../../utils/CheckNullParams";
const blogApi = {
  getBlogs: (params) => {
    const url = "blog";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getBlog: (id) => {
    const url = "blog";
    return axiosClient.get(url + "/" + id);
  },

  createBlog: (params) => {
    const url = "blog";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  updateBlog: (id, payload) => {
    const url = "blog/";
    return axiosClient.patch(url + id, payload);
  },
  // deleteBlog: (id) => {
  //   const url = "blog/";
  //   return axiosClient.delete(url + id);
  // },
  deleteBlog: (params) => {
    const url = "blog";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default blogApi;
